import { __assign } from "tslib";
import React from 'react';
import { Box, PinAll } from '@marvelapp/ui';
export default function Body(_a) {
    var children = _a.children, isCollapsed = _a.isCollapsed, onToggleCollapsed = _a.onToggleCollapsed;
    var collapsedProps = isCollapsed && {
        borderColor: 'smoke',
        borderRadius: 4,
        pl: 4,
        pt: 4,
        pb: 4,
    };
    return (React.createElement(Box, __assign({ alignItems: "center", border: "1px dashed", borderColor: "transparent", display: "flex", hoverBg: isCollapsed ? 'snow' : undefined, justifyContent: "space-between", pl: isCollapsed ? 4 : 10, position: "relative", width: 1, zIndex: "sectionHeader" }, collapsedProps),
        isCollapsed && React.createElement(PinAll, { cursor: "pointer", onClick: onToggleCollapsed }),
        children));
}
